import { palette } from "@brexhq/metal-foundation-shared";
import { useTheme } from "@emotion/react";
import React, { FC } from "react";

import { BlockContent } from "@brexhq/next/src/components/deprecated/BlockContent";
import { AdditionalFooterSection } from "@brexhq/next/src/components/shared/Footer/types";
import { legalFooter } from "@brexhq/next/src/data/siteSettings";
import { extractTextContent } from "@brexhq/next/src/utils/extractTextContent";
import { Text } from "@brexhq/shared/components/Typography/Text";
import { ThemeTextComponents } from "@brexhq/shared/types/modules/BlockRowsModule/BlockRowItems/TextRow";

export const LegalCopy: FC<AdditionalFooterSection> = ({
  additionalLegalFooterSection,
}) => {
  const generateFooterCopyContent = (): Array<any> => {
    const standardLegalCopy = legalFooter.copyRaw ?? [];

    const position = additionalLegalFooterSection?.position;
    const additionalLegalCopy = extractTextContent(
      additionalLegalFooterSection,
    );
    // const additionalLegalCopy =
    //   additionalLegalFooterSection != null &&
    //   "content" in additionalLegalFooterSection
    //     ? additionalLegalFooterSection["content"]
    //     : additionalLegalFooterSection?._rawContent;

    if (additionalLegalCopy && position === "above")
      return [...additionalLegalCopy, ...standardLegalCopy];
    if (additionalLegalCopy && position === "below")
      return [...standardLegalCopy, ...additionalLegalCopy];
    if (additionalLegalCopy && position === "overwrite") {
      return additionalLegalCopy;
    }
    return standardLegalCopy;
  };

  const { spacing } = useTheme();

  const footerCopy = generateFooterCopyContent();

  return (
    <Text
      as={ThemeTextComponents["Legal"].as}
      components={ThemeTextComponents["Legal"]?.components}
    >
      <BlockContent
        moduleTheme="PrimaryInk"
        color={{ Detail: palette.neutrals.coolGrey7 }}
        textMargin={{
          Detail: {
            LRG: [spacing.p8, 0, 0, 0],
          },
        }}
        blocks={footerCopy}
        defaultStyleRenderer="Detail"
      />
    </Text>
  );
};
